import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			[theme.breakpoints.up('sm')]: {
				flexWrap: 'wrap',
				'& $button': {
					minWidth: theme.spacing(20),
				},
			},
		},
		button: {
			width: '100%',
			height: '100%',
			maxWidth: '100%',
			minHeight: theme.spacing(6),
		},
		active: {},
	}),
	{ name: 'Questions-AnswerTypes-YesNoButtons' },
)

export default useStyles
